import { Wheat } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useModals } from "@/components/ModalContext";
import { Reveal } from "@/components/Reveal";

export const CtaBanner = () => {
  const { openContact, openSchedule } = useModals();

  return (
    <section data-testid="cta-section" className="pb-20 sm:pb-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <Reveal className="relative overflow-hidden rounded-[2.5rem] border border-arena bg-crema px-6 py-14 sm:px-12 lg:px-16 lg:py-20">
          <Wheat
            aria-hidden
            className="pointer-events-none absolute -right-10 -top-10 h-64 w-64 rotate-12 text-arena/50"
            strokeWidth={0.8}
          />
          <div className="relative flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
            <div>
              <h2 className="max-w-xl font-serif text-3xl leading-[1.14] tracking-tight text-tinta sm:text-4xl lg:text-[2.9rem]">
                ¿Tienes algo especial{" "}
                <em className="font-garamond font-medium italic text-cafe">en mente?</em>
              </h2>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-tinta/70">
                Encargos personalizados, celebraciones o simplemente un capricho dulce
                para hoy: cuéntanos tu idea y la hacemos realidad.
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <Button
                variant="outline"
                data-testid="cta-contact-button"
                onClick={() => openContact()}
                className="rounded-full px-8 py-6 text-base"
              >
                Contactar
              </Button>
              <Button
                data-testid="cta-schedule-button"
                onClick={openSchedule}
                className="rounded-full px-8 py-6 text-base"
              >
                Agendar llamada
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
